<template>
  <v-dialog persistent v-model="dialog" scrollable max-width="400px">
    <template v-slot:activator="{ attrs }">
      <v-btn
        dark
        icon
        :loading="loading"
        color="teal"
        v-bind="attrs"
        @click="OpenDialog"
      >
        <v-icon>
          fas fa-handshake
        </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>{{ Title }}</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-5">
        <!-- <p>{{ OtherCost }}</p> -->
        <v-form ref="OtherCostDeposit">
          <BaseDate :rules="rules.required" v-model="Deposit.date"></BaseDate>
          <BaseNumInput
            outlined
            :label="'Deposit Amount (' + OtherCost.CashType + ')'"
            :placeholder="'Amount (' + OtherCost.CashType + ')'"
            v-model.number="Deposit.Amount"
            :rules="[paymentRule]"
          ></BaseNumInput>

          <v-select
            v-if="isThereQaas"
            outlined
            :items="[{ AccountNumber: null, FullName: 'QAAS' }, ...QaasList]"
            v-model="Deposit.Qaas"
            item-value="AccountNumber"
            item-text="FullName"
            label="Where"
          ></v-select>

          <v-textarea
            placeholder="Write a details"
            label="Details"
            v-model="Deposit.Details"
            outlined
            rows="2"
            :rules="[rules.required]"
          ></v-textarea>
        </v-form>
        <p
          v-if="msgError"
          class="text--primary font-weight-black text-center"
          v-html="msgError"
        ></p>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <div>
          <cashDisplay :isloading="clicked" :Balance="TotalCash"></cashDisplay>
        </div>
        <v-spacer></v-spacer>
        <v-btn :disabled="clicked" color="blue darken-1" text @click="close"
          >Close</v-btn
        >
        <v-btn
          :loading="clicked"
          color="blue darken-1"
          text
          @click="OnOtherCostDeposit"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {
    cashDisplay: () => import("@/components/util/displayCash.vue"),
  },
  props: {
    OtherCost: { type: Object, required: true },
    Title: { type: String, required: true },
    BaseURL: { type: String, required: true },
    TotalCash: { type: Array, defoult: () => [] },
    ReloadFunc: { type: Function, required: true },
  },
  data() {
    return {
      URL: "/AccCharts",
      ReqURL: "/supplier/qaas",
      QaasList: [],
      cashType: "",
      msgError: null,
      clicked: false,
      loading: false,
      dialog: false,
      Deposit: {
        Details: null,
        Amount: null,
        Qaas: null,
        CashType: null,
        DepositID: null,
        date: "",
      },
      rules: {
        required: value => !!value || "Required.",
      },
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        // console.log(this.BaseURL);
        this.Deposit.date = this.Current().date;
      } else {
        this.Deposit.date = "";
      }
    },
  },
  computed: {
    isThereQaas() {
      return !!this.OtherCost.qaas && !!Object.keys(this.OtherCost.qaas).length;
    },
  },
  methods: {
    isGreaterthanZero(v) {
      return (v && v.toString().replace(/,/g, "") > 0) || "Amount is required";
    },
    paymentRule(v) {
      //   v = v.replace(/,/g, "");
      // console.log(v);
      let [Cash] = this.TotalCash;
      if (!Cash) Cash = { Amount: 0 };
      let andCon =
        v && v.replace(/,/g, "") > 0 && v.replace(/,/g, "") <= Cash.Amount;
      return andCon || "Invalid Amount";
    },
    getReq(url) {
      return this.$store.dispatch("GET_ONLY", url);
    },
    OnOtherCostDeposit() {
      this.msgError = null;
      // console.log(this.isThereQaas);
      if (this.$refs.OtherCostDeposit.validate()) {
        this.loading = true;
        this.Deposit.CashType = this.OtherCost.CashType;
        this.Deposit.DepositID = this.OtherCost._id;
        this.Deposit.SupBranch = this.OtherCost.type || null;
        this.Deposit.time = this.Current().time;
        this.clicked = true;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: this.BaseURL,
            data: this.Deposit,
          })
          .then(() => {
            this.clicked = false;
            this.ReloadFunc();
            this.close();
          })
          .catch(err => {
            this.clicked = false;
            this.msgError = err.response.data;
            this.loading = false;
            // console.log(err);
          });
      }
    },
    OpenDialog() {
      if (!this.isThereQaas || this.QaasList.length) {
        this.dialog = true;
        return;
      }
      this.loading = true;
      this.$store
        .dispatch("FIND_BY_VALUE", {
          url: this.ReqURL,
          query: { _id: this.OtherCost._id },
        })
        .then(result => {
          this.dialog = true;
          this.loading = false;
          this.QaasList = result.data;
          // console.log(result.data);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    close() {
      this.$refs.OtherCostDeposit.reset();
      this.dialog = false;
      this.msgError = "";
      this.loading = false;
    },
  },
};
</script>
